import ActionTypes from "../actionTypes";
import logger from "../../../utils/logger";


// Set organization roles data
export const setOrganizationRoles = roles => ({
  type: ActionTypes.SET_ORGANIZATION_ROLES,
  payload: roles,
});

// Set organization roles loading state
export const setOrganizationRolesLoading = loading => ({
  type: ActionTypes.SET_ORGANIZATION_ROLES_LOADING,
  payload: loading,
});

// Set organization roles error
export const setOrganizationRolesError = error => ({
  type: ActionTypes.SET_ORGANIZATION_ROLES_ERROR,
  payload: error,
});

// Clear organization roles data
export const clearOrganizationRoles = () => ({
  type: ActionTypes.CLEAR_ORGANIZATION_ROLES,
});

// Async action to fetch organization roles
export const fetchOrganizationRoles = () => {
  return async dispatch => {
    try {
      dispatch(setOrganizationRolesLoading(true));
      dispatch(setOrganizationRolesError(null));

      // Import apiV2Service dynamically to avoid circular imports
      const { apiV2Service } = await import("../../../services/apiV2Service");

      const response = await apiV2Service.getOrganizationRoles({
        active: true,
        limit: 100,
        orderBy: "name:asc",
      });

      const roles = response.data?.data || [];
      dispatch(setOrganizationRoles(roles));

      return roles;
    } catch (error) {
      logger.error("Error fetching organization roles:", error);
      dispatch(setOrganizationRolesError(error.message || "Failed to fetch organization roles"));
      throw error;
    } finally {
      dispatch(setOrganizationRolesLoading(false));
    }
  };
};
